<template>
    <div id="subpage">
        <el-col :span="24" class="warp-breadcrum">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <b>用户管理</b>
                </el-breadcrumb-item>
                <el-breadcrumb-item>订单号列表</el-breadcrumb-item>
            </el-breadcrumb>
        </el-col>
        <div class="content">
            <div class="xcx-head">
                <div style="display: flex">
                    <span>订单号列表</span>
                </div>
                <div style="display: flex">
                    <el-button @click="dialogFormVisible = true" size="small" icon="el-icon-plus"
                        type="success">批量导入</el-button>
                </div>
            </div>
            <div class="search-box">
                <el-form :inline="true">
                    <el-form-item>
                        <el-input placeholder="请输入订单号" v-model="searchs.mobile"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-select style="width:100%;" filterable v-model="searchs.packId" placeholder="请选择科目">
                            <el-option v-for="(item, index) in classData" :key="index" :label="item.title"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="getSearchIndex()" icon="el-icon-search" type="primary">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="getClearSearchIndex()" icon="el-icon-delete" type="info">清空筛选</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="xcx-content">
                <!--列表-->
                <el-table border max-height="650" :data="tableData" style="width: 100%" row-key="id" size="small" v-loading="loading"
                    default-expand-all :tree-props="{ children: 'childs', hasChildren: 'hasChildren' }">
                    <el-table-column align="center" prop="id" label="ID" width="80"></el-table-column>
                    <el-table-column align="center" prop="pack_name" label="栏目名称" width="260"></el-table-column>
                    <el-table-column align="center" prop="orderSn" label="订单号"></el-table-column>
                    <el-table-column align="center" prop="sort" label="状态" width="120">
                        <template #default="scope">
                            <el-tag v-if="scope.row.status" type="success">已激活</el-tag>
                            <el-tag v-else type="info">未激活</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="activePhone" label="激活手机号" width="160"></el-table-column>
                    <el-table-column align="center" prop="activeTime" label="激活时间" width="160"></el-table-column>
                    <el-table-column align="center" prop="created_at" label="导入时间" width="160"></el-table-column>
                    <el-table-column align="center" label="操作" width="120">
                        <template #default="scope">
                            <el-button size="mini" icon="el-icon-delete" type="danger"
                                @click="del_item(scope.row.id)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!--分页-->
                <div class="paging">
                    <el-pagination class="left" page-size="30" @current-change="handleCurrentChange" :current-page="page" background
                        layout="total, prev, pager, next" :total="count"></el-pagination>
                </div>
            </div>
        </div>

        <el-dialog title="批量导入订单号" width="36%" :visible.sync="dialogFormVisible">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
                <el-form-item label="科目类别：" :label-width="formLabelWidth" prop="packId">
                    <el-select style="width:100%;" filterable v-model="ruleForm.packId" placeholder="请选择科目">
                        <el-option v-for="(item, index) in classData" :key="index" :label="item.title"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="单号列表：" :label-width="formLabelWidth" prop="content">
                    <el-input type="textarea" :rows="12" placeholder="请输入订单号，每行一个,多个请换行导入" v-model="ruleForm.content"
                        autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            dialogFormVisible: false,
            loading: true,
            column_id: 0,
            subject_id: 0,
            tableData: [],
            classData: [],
            page: 0,
            count: 0,
            limit: 30,
            searchs: {
                mobile: "",
                packId: "",
            },
            ruleForm: {
                packId: "",
                content: "",
            },
            rules: {
                packId: [
                    { required: true, message: "请选择科目", trigger: "change" },
                ],
                content: [
                    { required: true, message: "请填写订单号", trigger: "blur" },
                ],
            },
            formLabelWidth: "120px",
        };
    },
    //进入页面加载
    mounted: function () {
        var that = this;
        that.getDyCate();
        that.getList();
    },
    methods: {

        getSearchIndex() {
            var that = this;
            that.getList();
        },

        getClearSearchIndex() {
            this.searchs.packId = "";
            this.searchs.mobile = "";
            this.getList();
        },

        del_item(ids) {
            console.log(ids);
            let that = this;
            this.$confirm("此操作不可逆, 是否继续?", "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    that.axios
                        .post("/delDouyinSn", {
                            ids: ids,
                        })
                        .then((res) => {
                            console.log(res);
                            if (res.code == 200) {
                                this.$message({
                                    type: "success",
                                    message: res.msg,
                                });
                                that.getList();
                            } else {
                                this.$message({
                                    type: "info",
                                    message: res.msg,
                                });
                            }
                        });
                });
        },

        /**
         * 下一页
         */
        handleCurrentChange(currentPage) {
            var that = this;
            that.page = currentPage;
            that.getList();
        },

        //获取抖音分类
        getDyCate() {
            let that = this;
            that.axios.post("/getDyCate").then((res) => {
                if (res) {
                    that.classData = res.data;
                }
            });
        },

        /**
         * 获取列表
         */
        getList() {
            let that = this;
            let formData = that.searchs;
            var curr_page = sessionStorage.getItem("curr_page");
            that.page = curr_page ? curr_page - 0 : that.page;
            formData.subject_id = that.subject_id;
            formData.page = that.page;
            formData.limit = that.limit;
            that.axios.post("/getDouyinSn", formData).then((res) => {
                if (res) {
                    that.tableData = res.data.data;
                    that.count = res.data.total;
                    that.page = curr_page ? curr_page : that.page;
                    curr_page ? sessionStorage.removeItem("curr_page") : "";
                }
                that.loading = false;
            });
        },

        /**
         * 提交信息
         */
        submitForm(formName) {
            const that = this;
            that.$refs[formName].validate((valid) => {
                if (!valid) return that.$message.warning("请完整填写内容!");
                var formData = {};
                formData = that.ruleForm;
                var url = "/saveDouyinSn";
                that.axios.post(url, formData).then((res) => {
                    if (res.data == 200) {
                        that.$message.success(that.id ? "修改成功" : "添加成功");
                        that.dialogFormVisible = false;
                        that.ruleForm.packId = "";
                        that.ruleForm.content = "";
                    } else {
                        that.dialogFormVisible = false;
                        that.ruleForm.packId = "";
                        that.ruleForm.content = "";
                        that.$message.warning(res.msg);
                    }
                    that.getList();
                });
            });
        },

    },
};
</script>
<style></style>